"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Vocabulary = _interopRequireDefault(require("./Vocabulary"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultVocabulary = new _Vocabulary["default"]();
defaultVocabulary.addPlural("$", "s");
defaultVocabulary.addPlural("s$", "s");
defaultVocabulary.addPlural("(ax|test)is$", "$1es");
defaultVocabulary.addPlural("(octop|vir|alumn|fung|cact|foc|hippopotam|radi|stimul|syllab|nucle)us$", "$1i");
defaultVocabulary.addPlural("(alias|bias|iris|status|campus|apparatus|virus|walrus|trellis)$", "$1es");
defaultVocabulary.addPlural("(buffal|tomat|volcan|ech|embarg|her|mosquit|potat|torped|vet)o$", "$1oes");
defaultVocabulary.addPlural("([dti])um$", "$1a");
defaultVocabulary.addPlural("sis$", "ses");
defaultVocabulary.addPlural("(?:([^f])fe|([lr])f)$", "$1$2ves");
defaultVocabulary.addPlural("(hive)$", "$1s");
defaultVocabulary.addPlural("([^aeiouy]|qu)y$", "$1ies");
defaultVocabulary.addPlural("(x|ch|ss|sh)$", "$1es");
defaultVocabulary.addPlural("(matr|vert|ind|d)ix|ex$", "$1ices");
defaultVocabulary.addPlural("(^[m|l])ouse$", "$1ice");
defaultVocabulary.addPlural("^(ox)$", "$1en");
defaultVocabulary.addPlural("(quiz)$", "$1zes");
defaultVocabulary.addPlural("(buz|blit|walt)z$", "$1zes");
defaultVocabulary.addPlural("(hoo|lea|loa|thie)f$", "$1ves");
defaultVocabulary.addPlural("(alumn|alg|larv|vertebr)a$", "$1ae");
defaultVocabulary.addPlural("(criteri|phenomen)on$", "$1a");
defaultVocabulary.addSingular("s$", "");
defaultVocabulary.addSingular("(n)ews$", "$1ews");
defaultVocabulary.addSingular("([dti])a$", "$1um");
defaultVocabulary.addSingular("(analy|ba|diagno|parenthe|progno|synop|the|ellip|empha|neuro|oa|paraly)ses$", "$1sis");
defaultVocabulary.addSingular("([^f])ves$", "$1fe");
defaultVocabulary.addSingular("(hive)s$", "$1");
defaultVocabulary.addSingular("(tive)s$", "$1");
defaultVocabulary.addSingular("([lr]|hoo|lea|loa|thie)ves$", "$1f");
defaultVocabulary.addSingular("(^zomb)?([^aeiouy]|qu)ies$", "$2y");
defaultVocabulary.addSingular("(s)eries$", "$1eries");
defaultVocabulary.addSingular("(m)ovies$", "$1ovie");
defaultVocabulary.addSingular("(x|ch|ss|sh)es$", "$1");
defaultVocabulary.addSingular("(^[m|l])ice$", "$1ouse");
defaultVocabulary.addSingular("(o)es$", "$1");
defaultVocabulary.addSingular("(shoe)s$", "$1");
defaultVocabulary.addSingular("(cris|ax|test)es$", "$1is");
defaultVocabulary.addSingular("(octop|vir|alumn|fung|cact|foc|hippopotam|radi|stimul|syllab|nucle)i$", "$1us");
defaultVocabulary.addSingular("(alias|bias|iris|status|campus|apparatus|virus|walrus|trellis)es$", "$1");
defaultVocabulary.addSingular("^(ox)en", "$1");
defaultVocabulary.addSingular("(matr|d)ices$", "$1ix");
defaultVocabulary.addSingular("(vert|ind)ices$", "$1ex");
defaultVocabulary.addSingular("(quiz)zes$", "$1");
defaultVocabulary.addSingular("(buz|blit|walt)zes$", "$1z");
defaultVocabulary.addSingular("(alumn|alg|larv|vertebr)ae$", "$1a");
defaultVocabulary.addSingular("(criteri|phenomen)a$", "$1on");
defaultVocabulary.addSingular("([b|r|c]ook|room|smooth)ies$", "$1ie");
defaultVocabulary.addIrregular("person", "people");
defaultVocabulary.addIrregular("man", "men");
defaultVocabulary.addIrregular("human", "humans");
defaultVocabulary.addIrregular("child", "children");
defaultVocabulary.addIrregular("sex", "sexes");
defaultVocabulary.addIrregular("move", "moves");
defaultVocabulary.addIrregular("goose", "geese");
defaultVocabulary.addIrregular("wave", "waves");
defaultVocabulary.addIrregular("die", "dice");
defaultVocabulary.addIrregular("foot", "feet");
defaultVocabulary.addIrregular("tooth", "teeth");
defaultVocabulary.addIrregular("curriculum", "curricula");
defaultVocabulary.addIrregular("database", "databases");
defaultVocabulary.addIrregular("zombie", "zombies");
defaultVocabulary.addIrregular("personnel", "personnel");
defaultVocabulary.addIrregular("cache", "caches");
defaultVocabulary.addUncountable("equipment");
defaultVocabulary.addUncountable("information");
defaultVocabulary.addUncountable("corn");
defaultVocabulary.addUncountable("milk");
defaultVocabulary.addUncountable("rice");
defaultVocabulary.addUncountable("money");
defaultVocabulary.addUncountable("species");
defaultVocabulary.addUncountable("series");
defaultVocabulary.addUncountable("fish");
defaultVocabulary.addUncountable("sheep");
defaultVocabulary.addUncountable("deer");
defaultVocabulary.addUncountable("aircraft");
defaultVocabulary.addUncountable("oz");
defaultVocabulary.addUncountable("tsp");
defaultVocabulary.addUncountable("tbsp");
defaultVocabulary.addUncountable("ml");
defaultVocabulary.addUncountable("l");
defaultVocabulary.addUncountable("water");
defaultVocabulary.addUncountable("waters");
defaultVocabulary.addUncountable("semen");
defaultVocabulary.addUncountable("sperm");
defaultVocabulary.addUncountable("bison");
defaultVocabulary.addUncountable("grass");
defaultVocabulary.addUncountable("hair");
defaultVocabulary.addUncountable("mud");
defaultVocabulary.addUncountable("elk");
defaultVocabulary.addUncountable("luggage");
defaultVocabulary.addUncountable("moose");
defaultVocabulary.addUncountable("offspring");
defaultVocabulary.addUncountable("salmon");
defaultVocabulary.addUncountable("shrimp");
defaultVocabulary.addUncountable("someone");
defaultVocabulary.addUncountable("swine");
defaultVocabulary.addUncountable("trout");
defaultVocabulary.addUncountable("tuna");
defaultVocabulary.addUncountable("corps");
defaultVocabulary.addUncountable("scissors");
defaultVocabulary.addUncountable("means");
defaultVocabulary.addUncountable("mail");
var _default = defaultVocabulary;
exports["default"] = _default;